import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {DynamicCrudService} from "../../../app/shared/_services/dynamic-crud.service";
import {GetFromLocalStorage} from "../../Utility/Utility";
import {GlobalStoreService} from "../../../app/shared/_services/global-store.service";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";

export function AddButtonCard(){
 return  {
   nome: 'Richiedi',
   close: false,
   icon: 'fa-solid fa-bag-shopping',
   class: ' btn ',
   single:true,
   noGet:true,
   labelClass: 'text-success ',
   type: 'func',
   tooltip: "Richiedi Prodotto",
   func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService, component: DynamicCrudService)=>{
     //RichiediProdotto(field, api, component.store)
     component.router.navigate([
       'marketplace/shared/dynamicedit/catalogo',
       field?.id
     ]);
     console.log("Aggiungi al carrello...")
   },
 }
}
export function preferitiAddButtonCard(){
  return  {...AddButtonCard(), nome: "Aggiungi al carrello", icon: null}
}
export function ImageUrl(item, component){
  return `${component.api.getBaseAPI()}/file/image/${item.id_immagine}`
}


export function productCrudUtility(preferiti: boolean){
  return {
    ImageUrl: ImageUrl,
    AddButtonCard: preferiti ? preferitiAddButtonCard() : AddButtonCard(),
    cardButtons:[
      {
        class: "fav-badge-off",
        func:(item, component: DynamicListComponent)=>{},
        hideif: {func:(prodotto,component: FieldViewerComponent)=>GetMyPrice(prodotto, GetFromLocalStorage('currentUser')).isPromo},
        content:(prodotto, component: DynamicListComponent)=>  `-${GetMyPrice(prodotto, GetFromLocalStorage('currentUser')).sconto}%`,
      },
      {
        class: 'fav-badge-new',
        func:(item, component: DynamicListComponent)=>{},
        hideif: {func:(x)=>x.new},
        content:(item, component: DynamicListComponent)=>"NEW",
      },
      {
        class: 'fav-heart',
        func:(item, component: DynamicListComponent)=>{
          item.preferito = item.preferito?.filter(id => id !== GetFromLocalStorage('currentUser')?.id);
          component.api.ClassicPost('/prodotti/preferiti/delete', {id: item.id}).subscribe(
            ()=>{
              component.Refresh();
            }
          )
        },
        hideif: {func:(x)=>x.preferito?.includes(GetFromLocalStorage('currentUser')?.id)},
        content:(item, component: DynamicListComponent)=>"❤️",
      },
      {
        class: 'fav-heart',
        func:(item, component: DynamicListComponent)=>{
          item.preferito = [...(item.preferito ?? []), GetFromLocalStorage('currentUser')?.id];
          component.api.ClassicPost('/prodotti/preferiti/add', {id: item.id}).subscribe(
            ()=>{
              component.Refresh();
            }
          )
        },
        hideif: {func:(x)=>!x.preferito?.includes(GetFromLocalStorage('currentUser')?.id)},
        content:(item, component: DynamicListComponent)=>"🖤",
      },
    ],
  }

}

export function GetCarrello(){
  return GetFromLocalStorage('carrello') ?? [];
}
export function GetCarrelloCount(store: GlobalStoreService){
  return (store.CartData.dataCarrello).reduce((acc, item) => acc + item.progetti.reduce((acc2, item2) => acc2 + item2.voci.length, 0), 0);
}
export function GetCarrelloVoci(data?: any[]){
  return (data ?? GetCarrello()).reduce((acc, item) => [
    ...acc,
    ...(item.progetti?.reduce((acc2, item2) => [
      ...acc2,
      ...(item2.voci || [])
    ], []) || [])
  ], []);
}

export function CalcolaIva(prezzo:number,iva:number){
  if (isNaN(prezzo) || isNaN(iva)) {
    throw new Error('Valori non validi');
  }
  return (prezzo * (iva / 100));
}
export function PrezzoIvato(prezzo:number,iva:number){
  return Math.round((prezzo + CalcolaIva(prezzo, iva)) * 100) / 100;
}

export function GetImponibile(prezzo,iva:number=22){
  var prezzoIvato = parseFloat(prezzo?.toString()?? '0');
  var imp = prezzoIvato / ((100+iva) /100)

  return   (Math.round(imp * 1000) / 1000);
}

export function GetMyPrice(prodotto:{prezzi:{prezzo:string | number, um:number, umlabel: string}[], promozione:{tipo: string, data: string, dataScadenza: string, sconto: {prezzoNetto: number, prezzo: number}[]}[]}, UtenteLoggato:any){
  var myUm = prodotto.prezzi?.find(prezzo => (!UtenteLoggato.ruoliObject.find(r=>r.id == 'C') && prezzo.umlabel.toLowerCase() == 'b2b') || UtenteLoggato.tipiObject?.find(tipo => tipo.label?.toLowerCase() == prezzo.umlabel?.toLowerCase()));
  var prezzo = parseFloat(myUm?.prezzo?.toString() ?? '0') ?? 0;

  var out:{prezzo:number, um:number, iva:number, prezzoIvato:number, isPromo:boolean, sconto?:number, inizioSconto?:string, fineSconto?: string, prezzoSconto?:number } = {
    prezzo: prezzo,
    um: myUm?.um ?? null,
    iva: 22,
    prezzoIvato: PrezzoIvato(prezzo ?? 0, 22),
    isPromo: false
  }
  var promo = prodotto.promozione?.find(p=>p.tipo == myUm.umlabel);
  if(promo){
    out.sconto = promo.sconto.find(sc=>true).prezzoNetto;
    out.prezzoSconto = promo.sconto.find(sc=>true).prezzo;
    out.inizioSconto = promo.data;
    out.fineSconto = promo.dataScadenza;
    out.isPromo = true;
  }
  return out;
}

export function RichiediProdotto(field, api:ApiPathsService, store: GlobalStoreService){
  console.log("Richiedi Prodotto...");
  console.log("Prodotto: ", field);
  if (!field.taglia) {
    api.toastService.warning("Inserisci la taglia");
    return;
  }
  var prezzo= GetMyPrice(field, GetFromLocalStorage('currentUser'))
  api.ClassicPost("/progetti/carrello/add", {
    prodotto_id :field.id,
    quantita: field.qta ?? 1,
    prezzo:  prezzo.isPromo ? parseFloat(GetImponibile(prezzo.prezzoSconto)?.toString() ?? '0') : prezzo.prezzo,
    voce: field.prodotto,
    um_id:  prezzo.um,
    taglia: field.taglia,
    iva: 22
  }).subscribe(()=>{
    api.toastService.success("Prodotto aggiunto alle richieste","",{toastClass:'marketplace-success-toast'});
    field.qta = 1;
    store.getCartData();
    store.toggleCart();
  })
}

function toBase64(url: string): Promise<string> {
  return fetch(url)
    .then(res => res.blob())
    .then(blob => new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    }));
}
export async function urlsToBase64(urls: string[]): Promise<string[]> {
  const promises = urls.map(url => toBase64(url));
  return Promise.all(promises);
}

export async function idsToBase64(id_immagine:number[], route:string): Promise<string[]> {
  const promises = id_immagine.map(url => toBase64(`${route}/file/image/${url}`));
  return Promise.all(promises);
}
export function getSpedizione(esclusiva: {esclusiva:{id: number, nominativo: string}, items: {prodotto_cart: any, prodotto: any}[]}, maggiorazione: number, costoFisso){
  console.log(maggiorazione, costoFisso, getEsclusivaSubtotal(esclusiva))
  var costoperc = (getEsclusivaSubtotal(esclusiva)/100) * maggiorazione;
  return costoFisso + costoperc;
}
export function getEsclusivaSubtotal(esclusiva) {
  return esclusiva.items.reduce((acc, item) => {

    const quantita = Number(
      item?.prodotto_cart?.quantita ??
      item?.quantita ??
      item?.prodotto_cart.quantitaRic ??
      1
    );


    if (item.prodotto?.prezzi?.length) {
      const prezzo = GetMyPrice(
        item?.prodotto ,
        GetFromLocalStorage('currentUser')
      );

      const prezzoUnitario = prezzo?.isPromo
        ? Number(prezzo.prezzoSconto ?? 0)
        : Number(prezzo.prezzoIvato ?? 0);

      return acc + (quantita * prezzoUnitario);
    }

    var pivato = PrezzoIvato(Number((item?.prodotto_cart?.prezzo) ?? item?.prezzo ?? 0), 22);
    return acc + (
      quantita *
      (item?.prodotto_cart?.sconto ? (pivato - (pivato * (parseFloat(item?.prodotto_cart?.sconto.toString()) / 100))) : pivato)
    );

  }, 0);
}

declare global {
  interface Number {
   toDecimals(number: number): string;
  }
}
Number.prototype.toDecimals = function (num): string {
  var valore = this;
  return (Math.round(valore * 100) / 100).toFixed(num);
}


